module.exports = __webpack_public_path__ + "img/balls-landscape-x1.ee7f927b.jpg";